import { useQuery } from '@tanstack/react-query';

/**
 * Reusable useQuery wrapper enforcing standard behavior
 * @param {Array} queryKey - Unique identifier for the query
 * @param {Function} queryFn - Promise-returning function to fetch data
 * @param {Object} options - Additional React Query options
 */
export function useApiQuery(queryKey, queryFn, options = {}) {
  return useQuery({
    queryKey,
    queryFn,
    staleTime: 3 * 60 * 1000, // 3 minutes
    retry: 1,                 // Retry 1 time explicitly
    ...options,
  });
}
